function isGoogleDocsTitle(domNode: Node): boolean {
    if (domNode.nodeName.toLowerCase() === 'span') {
        return (domNode as HTMLSpanElement).style.fontSize === '26pt'
    }
    return false
}

export { isGoogleDocsTitle }
